<template>
  <div>
    <v-menu
        v-model="open"
        rounded="lg"
        offset-y
        style="z-index:10000"
        min-width="420"
        max-width="420"
        :close-on-content-click="false"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn v-bind="attrs" v-on="on" icon class="mr-2">
          <v-badge
              :content="unreadTotal > 99 ? '99+' : unreadTotal"
              :value="unreadTotal > 0"
              color="red"
              overlap
          >
            <v-avatar size="36">
              <v-icon>mdi-message-text</v-icon>
            </v-avatar>
          </v-badge>
        </v-btn>
      </template>
      <v-sheet width="420" :height="widgetHeight" class="overflow-hidden d-flex flex-column">
        <dialog-page-chat
            v-if="selectChat"
            :height="widgetHeight"
            :cats="cats"
            :chat="selectChat"
            :messageTemplates="[]"
            :small="true"
            @close="selectChat=null"
        />
        <div v-else class="d-flex flex-column fill-height">
          <v-toolbar dense flat>
            <v-toolbar-title class="body-1">Чаты</v-toolbar-title>
            <v-spacer/>
            <v-menu offset-y left :close-on-content-click="false">
              <template v-slot:activator="{ attrs, on }">
                <v-btn v-bind="attrs" v-on="on" depressed small class="mr-2">
                  Уведомления
                  <v-icon small class="ml-1">mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <radios :items="notifModes" :select.sync="notifSelect" class="mb-0"/>
            </v-menu>
            <v-btn
                depressed
                small
                @click="openFullPage"
            >
              Открыть
              <v-icon class="ml-1" small>mdi-open-in-new</v-icon>
            </v-btn>
          </v-toolbar>
          <v-divider/>
          <div class="position-relative">
            <v-progress-linear v-if="chatsLoading" indeterminate color="primary" class="position-absolute"/>
            <dialog-page-chats
                :height="widgetHeight - 49"
                :selectChat.sync="selectChat"
                onlyMyChats
                @loading="(v1)=>chatsLoading=v1"
                @unreadCount="recalcUnreadTotal()"
            />
          </div>
        </div>
      </v-sheet>
    </v-menu>
    <audio ref="ring">
      <source src="../../../assets/ring.mp3" type="audio/mpeg">
    </audio>
  </div>
</template>

<script>
import DialogPageChats from "./components/DialogPageChats.vue";
import DialogPageChat from "./components/DialogPageChat.vue";
import Radios from "../../../componentsV2/base/Radios.vue";
import axios from "axios";
import {applyDialogUserConfig, emptyDialogUserConfig, saveDialogNotif, shouldPlayDialogRing} from "./dialogNotif";

export default {
  components: {DialogPageChat, DialogPageChats, Radios},
  data: () => ({
    open: false,
    selectChat: null,
    widgetHeight: 550,
    cats: [
      {id: 'internal', name: 'Рабочий', icon: 'mdi-account-tie'},
      {id: 'queue', name: 'Очередь', icon: 'mdi-account-question'},
      {id: 'process', name: 'Обработка', icon: 'mdi-account-clock'},
      {id: 'closed', name: 'Закрытые', icon: 'mdi-account-remove'},
    ],
    chatDatas: [],
    unreadTotal: 0,
    subscribeListenerId: null,
    chatsLoading: false,
  }),
  computed: {
    notifModes() {
      return this.$store.state.dialogUserConfig?.notifs || [];
    },
    notif() {
      return this.$store.state.dialogUserConfig?.notif;
    },
    notifMode() {
      return this.notifModes.find(v => v.id === this.notif) || this.notifModes[0] || null;
    },
    notifSelect: {
      get() {
        return this.notifMode;
      },
      set(v) {
        if (v?.id && v.id !== this.notif)
          saveDialogNotif(this.$store, axios, v.id);
      },
    },
  },
  mounted() {
    this.initWs();
  },
  beforeDestroy() {
    this.destroyWs();
  },
  watch: {
    open(v) {
      if (!v)
        this.selectChat = null;
    },
    '$store.state.user'(user, oldUser) {
      if (user === null) {
        this.chatDatas = [];
        this.unreadTotal = 0;
        this.selectChat = null;
        this.open = false;
        this.$store.commit('setDialogUserConfig', emptyDialogUserConfig());
        this.destroyWs();
      } else if (oldUser === null || user.id !== oldUser?.id) {
        this.initWs();
      }
    },
  },
  methods: {
    initWs() {
      if (this.$store.state.user === null)
        return;
      this.loadUnreadCount();
      this.loadUserConfig();
      if (this.subscribeListenerId !== null)
        return;
      this.$ws.connectWithSubscribeListener(this.$store.state.user, (v) => this.subscribeListenerId = v, (m) => {
        if (m.type === 'dialogChat')
          this.onDialogChatWs(m.data);
        if (m.type === 'dialogChatUnread')
          this.dialogChatUnreadEvent(m.data);
        if (m.type === 'dialogUserConfig')
          applyDialogUserConfig(this.$store, m.data);
      });
    },
    destroyWs() {
      this.$ws.removeSubscribeListener(this.subscribeListenerId);
      this.subscribeListenerId = null;
    },
    openFullPage() {
      this.open = false;
      this.$router.push('/contactCenter/dialog/');
    },
    loadUnreadCount() {
      if (this.$store.state.user === null)
        return;

      axios.get('/napi/dialog/chat/')
          .then(r => {
            this.chatDatas = [];
            r.data.forEach(v => this.dialogChatEvent(v));
          });
    },
    loadUserConfig() {
      if (this.$store.state.user === null)
        return;
      axios.get('/napi/dialog/user/config/')
          .then(r => applyDialogUserConfig(this.$store, r.data))
          .catch(() => applyDialogUserConfig(this.$store, emptyDialogUserConfig()));
    },
    onDialogChatWs(data) {
      const userId = this.$store.state.user?.id;
      const inChat = data.dialogUsers?.some(v => v.user?.id === userId);

      if (!inChat) {
        const index = this.chatDatas.findIndex(v => v.id === data.id);
        if (index !== -1)
          this.chatDatas.splice(index, 1);
        if (this.selectChat?.id === data.id)
          this.selectChat = null;
        this.recalcUnreadTotal();
      } else {
        this.dialogChatEvent(data);
      }

      if (shouldPlayDialogRing(data, userId, this.$store.state.dialogUserConfig))
        this.playDialogRing();
    },
    playDialogRing() {
      this.$tools.debounce(() => {
        if (document.visibilityState !== 'visible') return;
        this.$refs.ring?.play();
      }, 100, 'dialogRing');
    },
    dialogChatEvent(data) {
      const userId = this.$store.state.user?.id;
      if (!data.dialogUsers?.some(v => v.user?.id === userId))
        return;

      const index = this.chatDatas.findIndex(v => v.id === data.id);
      if (index === -1)
        this.chatDatas.push(data);
      else
        this.chatDatas[index] = data;

      if (this.selectChat?.id === data.id)
        this.selectChat = data;

      this.recalcUnreadTotal();
    },
    dialogChatUnreadEvent(data) {
      const index = this.chatDatas.findIndex(v => v.id === data.id);
      if (index === -1)
        return;
      this.chatDatas[index]._unreadCount = data.count;
      this.recalcUnreadTotal();
    },
    recalcUnreadTotal() {
      const userId = this.$store.state.user?.id;
      this.unreadTotal = this.chatDatas
          .filter(chat => chat.dialogUsers?.some(v => v.user?.id === userId))
          .reduce((sum, chat) => sum + (chat._unreadCount || 0), 0);
    }
  },
}
</script>
